module.exports = __webpack_public_path__ + "img/5a7ce91a9df0bc8ef096419f6c6d9f48.png";